/* eslint-disable react/no-unescaped-entities */
import { Box, Button, Grid, TextField, Typography, useMediaQuery, useTheme, Alert, AlertTitle } from '@mui/material'; // Adicione Alert e AlertTitle
import { ToolsDamInformation } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { CustomAlert, VListInstruments, VMenu, VSelecInstruments } from '../../components/shared';
import { useParams } from 'react-router-dom';
import { Download, Save } from '@mui/icons-material';
import { useState } from 'react';
import { InstrumentsServices } from '../../services/api/instruments/InstrumentosServices';
import { useAuthContext } from '../../context';


export const ImportInstruments = () => {
    const url = useParams();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const { userData } = useAuthContext();
    const permissoes = userData.permissoes;

    const [type, setType] = useState<string | undefined>(undefined);
    const [instrumentId, setInstrumentId] = useState<string>('');


    function handleTipo(newType: string) {
        setType(newType);
    }

    function handleSelectInstrument(newId: string) {
        setInstrumentId(newId);
    }

    const [spreadsheet, setSpreadsheet] = useState<File | null>(null);

    function handleSpreadsheet(input: HTMLInputElement) {
        const newSpreadsheet = input.files?.[0] || null;
        setSpreadsheet(newSpreadsheet);
    }

    async function saveSpreadsheet(instrment: string) {
        setAlertInfo({ open: false, message: 'Planilha enviado! ', severity: 'success' });
        try {
            if (spreadsheet instanceof File) {
                const response = await InstrumentsServices.saveSpreadsheet(instrment, spreadsheet);
                if (response.data === 'Erro: Existem valores inexistentes nas colunas obrigatórias!') {
                    setAlertInfo({ open: true, message: 'Erro: Existem valores inexistentes nas colunas obrigatórias! ', severity: 'error' });
                    return;
                }
                setAlertInfo({ open: true, message: 'Planilha enviado! ', severity: 'success' });
            }
        } catch (error) {
            setAlertInfo({ open: true, message: 'Não foi enviar a planilha! ' + error, severity: 'error' });
        }
    }

    async function downloadSpreadsheet(type: string) {
        try {
            const response = await InstrumentsServices.getSpreadsheet(type);
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${type}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao fazer download do CSV! ' + error, severity: 'error' });
        }
    }

    return (
        <LayoutBase
            title='Importação de Leituras'
            tollBar={<ToolsDamInformation />}
        >
            <Box width={'100%'}>
                <VMenu id={url.id} />
                <Box width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} >
                    <Grid width={'100%'} sx={{ padding: 2 }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography variant='h6'>
                                    Importar leituras de instrumentos
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Alert severity="info" sx={{ width: '100%', maxWidth: '600px' }}>
                                    <AlertTitle color={'primary'}>Atenção!</AlertTitle>
                                    Para importar as leituras, abrir somente o arquivo de exemplo no excel
                                    e preencher todos os campos (apenas comentários não são obrigatórios),
                                    salvar com "ctrl + b" e enviar.
                                </Alert>
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <VSelecInstruments onTipoChange={(newType) => handleTipo(newType)} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    variant="contained"
                                    startIcon={<Download />}
                                    sx={{ borderRadius: '25px', height: '50px' }}
                                    disabled={!type}
                                    onClick={() => type ? downloadSpreadsheet(type) : null}
                                >
                                    Planilha modelo
                                </Button>
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <VListInstruments id_dam={url.id} type={type} changeSelectInstrument={(newId) => handleSelectInstrument(newId)} />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    variant='outlined'
                                    type='file'
                                    fullWidth
                                    inputProps={{ accept: '.csv' }}
                                    onChange={(e) => handleSpreadsheet(e.target as HTMLInputElement)}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                {permissoes.includes('add') && 
                                    <Button startIcon={<Save />} sx={{ borderRadius: '25px', height: '50px', width: '200px' }} variant='contained' disabled={!spreadsheet} onClick={() => instrumentId ? saveSpreadsheet(instrumentId) : null}>
                                        Salvar
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                />
            }
        </LayoutBase>
    );
};